import Vue from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue';
import router from './router';
import './styles/global.css';

Vue.use(Vant);
Vue.config.productionTip = false;

// 移动端调试提示关闭
if (process.env.NODE_ENV !== 'production') console.log('开发模式');

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
